import React from "react";
import TimeseriesChart from "@/charts/TimeseriesChart";

const TimeseriesAdapter = ({ spec, containerRef }) => {
  const { config = {}, data = [], title } = spec;
  const firstRow = data[0] || {};
  const rowKeys = Object.keys(firstRow);

  const xKey =
    config.xKey ||
    ["date", "week", "month", "day", "time", "key", "timestamp"].find((k) => k in firstRow) ||
    rowKeys[0] ||
    "date";
  
  // Auto-detect series if not explicitly provided
  let series = config.series;
  if (!series || !series.length) {
    const firstRow = data[0] || {};
    const numericKeys = Object.keys(firstRow).filter(
      (k) => k !== xKey && typeof firstRow[k] === "number"
    );
    series = numericKeys.length
      ? numericKeys.map((k) => ({
          yKey: k,
          label: k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, " "),
        }))
      : [{ yKey: "value", label: "Value" }];
  }

  const chartType = config.chartType || "area";

  return (
    <div ref={containerRef} className="assistant-chart-render-wrapper timeseries-render-wrapper">
      <TimeseriesChart
        data={data}
        isLoaded={true}
        title={title}
        xKey={xKey}
        series={series}
        chartType={chartType}
        startDate={config.startDate || null}
        endDate={config.endDate || null}
        height={config.height ? `${config.height}px` : "280px"}
      />
    </div>
  );
};

export default TimeseriesAdapter;
